// extracted by mini-css-extract-plugin
export var linkButton = "link-button-module--link-button--obdqb";